// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__2hrtF","info":"PatientInfo_info__cSVQ4"};